'use client'

import type { MouseEvent } from 'react'

import { Icon, IconComponent, Tooltip } from '@graftcode/design-system'

import { GRAFTABILITY_WARNING_ICON_CLASS } from '@/core/components/GraftabilityRow'
import type { GraftabilityIssue } from '@/core/utils/graftability'
import { getGraftabilityIssueSummary } from '@/core/utils/graftability/formatGraftabilityIssue'

import styles from './MemberGraftabilityHint.module.scss'

interface MemberGraftabilityHintProps {
  issues: GraftabilityIssue[]
}

export function MemberGraftabilityHint({ issues }: MemberGraftabilityHintProps) {
  if (issues.length === 0) return null

  const tooltip = issues.map((issue) => getGraftabilityIssueSummary(issue)).join(' ')

  const stopPropagation = (event: MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation()
  }

  return (
    <Tooltip content={tooltip}>
      <span
        className={styles.hint}
        aria-label="Method has graft compatibility issues"
        onClick={stopPropagation}
        onPointerDown={stopPropagation}
      >
        <IconComponent icon={Icon.WarningFilled} size={14} className={GRAFTABILITY_WARNING_ICON_CLASS} />
      </span>
    </Tooltip>
  )
}
